
export const API_CONFIG = {
  BASE_URL: process.env.API_URL || 'https://em2w.azurewebsites.net/api',
  
  TIMEOUT: 15000,
  ENDPOINTS: {
    // Asset Type endpoints
    ASSET_TYPES: '/assettype',                        // GET all asset types
    ASSET_TYPE_BY_ID: '/assettype/{id}',             // GET, PUT, DELETE asset type by ID
    
    // Asset endpoints
    ASSETS: '/asset',                                 // GET all assets, POST new asset
    ASSET_BY_ID: '/asset/{id}',   
    
    // User endpoints
    CURRENT_USER: '/user/current',

    SYSTEM_LANGUAGE: '/system/language',
    
    USER_CURRENT_IMAGE: '/user/current/image',

    USER_CURRENT_ORG: '/user/current/organization',

    DISTRB_OCR: '/documentintelligence/distributionboard'
    
  }
};


// Headers configuration
export const API_HEADERS = {
  'Content-Type': 'application/json',

};


export const getApiConfig = () => {
  return {
    ...API_CONFIG,
    BASE_URL: process.env.API_URL || 'https://em2w.azurewebsites.net/api',
    TIMEOUT: 20000,
    DEBUG: false
  };
};

// Helper function to build URLs with parameters
export const buildUrl = (endpoint: string, params: Record<string, string> = {}): string => {
  let url = endpoint;
  
  // Replace path parameters
  Object.entries(params).forEach(([key, value]) => {
    url = url.replace(`{${key}}`, encodeURIComponent(value));
  });
  
  return url;
};

